module.exports = __webpack_public_path__ + "static/media/cliente-cnpj.ea8d4940.svg";